/* loaded by smart-asset */
export default require("./walnuts~VdYLyOvB.png")